import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://api-pruebas.indagrovalles.com/api',
});

export default axiosInstance;
